import { Component, OnInit, ViewChild, ElementRef, inject } from '@angular/core';
import { APIService } from 'src/app/services/APIService/api.service';
import { first } from 'rxjs/operators';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import shajs from 'sha.js';
import { ToastrService } from 'ngx-toastr';
import { ClrDatagrid } from '@clr/angular';
import { MrTranslatePipe } from 'src/app/pipes/mr-translate.pipe';
import { AuthService } from 'src/app/services/Auth/auth.service';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { ClarityModule } from '@clr/angular';
import { FormControl, FormsModule, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { HideIDColumnsPipe } from 'src/app/pipes/hide-idcolumns.pipe';
import { SpinnerService } from 'src/app/services/Spinner/spinner.service';
import { Table } from 'src/app/models/ui/table';
import { ActionDefinition, AppfxDatagridModule, ColumnDefinition } from '@clr/addons/datagrid';
import { ConfirmService } from 'src/app/services/confirm.service';
import { ExcelService } from 'src/app/services/Shared/excel.service';

@Component({
  selector: 'app-benutzerverwaltungsdialog',
  templateUrl: './benutzerverwaltungsdialog.component.html',
  styleUrls: ['./benutzerverwaltungsdialog.component.scss'],
  imports: [
    CommonModule,
    ClarityModule,
    FormsModule,
    ReactiveFormsModule,
    HideIDColumnsPipe,
    MrTranslatePipe,
    AppfxDatagridModule,
  ],
  providers: [TitleCasePipe, HideIDColumnsPipe],
})
export class BenutzerverwaltungsdialogComponent implements OnInit {
  private apiservice = inject(APIService);
  private toastr = inject(ToastrService);
  private hideID = inject(HideIDColumnsPipe);
  private mrTranslate = inject(MrTranslatePipe);
  private titleCase = inject(TitleCasePipe);
  private confirmService = inject(ConfirmService);
  private authService = inject(AuthService);
  private spinnerservice = inject(SpinnerService);
  private readonly excelService = inject(ExcelService);

  constructor() {
    this.trial = this.authService.getToken().trial;
    this.token = this.authService.getToken().email;
    this.spinnerservice.enable();
    this.useMFA = this.authService.twofa.value == 2;
  }

  ngOnInit() {
    this.loadRoles();
  }

  public closedialog: BehaviorSubject<boolean> = new BehaviorSubject(false);
  @ViewChild(ClrDatagrid) grid: ClrDatagrid;
  @ViewChild('_verantwortung') _verantwortung: ElementRef;

  protected formUser = new FormGroup({
    id: new FormControl<number>(0),
    username: new FormControl<string>('', [Validators.required]),
    alias: new FormControl<string>(''),
    pw: new FormControl<string>('', [Validators.required]),
    role: new FormControl<number>(null, [Validators.required, Validators.min(1)]),
    vname: new FormControl<string>('', [Validators.required]),
    nname: new FormControl<string>('', [Validators.required]),
    email: new FormControl<string>('', [Validators.required]),
    mobil: new FormControl<string>('', [Validators.required]),
    optalv: new FormControl<boolean>(false),
    optebl: new FormControl<boolean>(false),
  });

  protected formUserGroup = new FormGroup({
    id: new FormControl<any>('INSERT'),
    name: new FormControl<string>('', [Validators.required]),
    rechte: new FormControl<number>(1),
  });

  protected formUserAuftragGroup = new FormGroup({
    id: new FormControl<any>('INSERT'),
    name: new FormControl<string>('', [Validators.required]),
    kost: new FormControl<string>(''),
  });

  protected formRole = new FormGroup({
    id: new FormControl<number>(0),
    rolle: new FormControl<string>('', [Validators.required]),
    rechte: new FormControl<number>(1),
  });

  actionDefs: ActionDefinition[];
  colDefs: ColumnDefinition<iFECol>[] = [];
  hideIDColumns: string[] = [
    'kprolid',
    'userimagebase64',
    'eisenbahnbetriebsleiter (ebl)',
    'anlagenverantwortlicher (alv)',
    'user_ebl',
    'user_alv',
    'status',
    'pwhash',
  ];
  auftragsGroups: any;
  useMFA: boolean = false;
  users: any;
  pwini: any;
  locked: boolean = true;
  token: any;
  trial = false;
  groups: any[] = [];
  selectedUserRights: any = undefined;
  selectedUserGroups: any = [];
  selectedUserAuftragGroups: any = [];
  roles: Table = { columns: [], rows: [] };
  rolesrights: any = [];
  rightEntry: any;

  file: any;
  selectedUserRole: any = [];
  selectedRole: any;
  selectedRoleRechte: number = 1;
  showEditRole: boolean = false;
  showEditRoleTitle: string = 'Neue Rolle anlegen';
  curSelectedRole: any;
  showEditGroupTitle: string = 'Neue Gruppe anlegen';
  showEditAuftragsGroupTitle: string = 'Neue Auftragsgruppe anlegen';
  showUserGroupTitle: string = 'Neue Benutzer anlegen';

  isUserEditVisible: boolean = false;
  isGroupEditVisible: boolean = false;
  showAufGroupEdit: boolean = false;

  sotyp: any;
  bild: string;
  _file: string = '';

  edituser: any;
  base64Image: String;

  optPWkBuch: boolean = true;
  optPWgBuch: boolean = true;
  optPWZahl: boolean = true;
  optPWSonder: boolean = true;

  optPWMinL: number = 6;
  optAzkBuch: number = 1;
  optAzgBuch: number = 1;
  optAzZahl: number = 1;
  optAzSonder: number = 1;

  optPWExpire: String = '0';
  optShowExpireDate: boolean = false;
  optPWExpireDays: number = 30;
  optPWHistoryCount: number = 0;

  chkView: number = 0;
  chkPro: number = 0;
  chkType: any = [];

  optPWAdminMinL: number = 6;
  optAdminUsePW: boolean = false;
  optAdminMFA: boolean = false;

  groupRights = {
    1: this.mrTranslate.transform('lesen'),
    2: this.mrTranslate.transform('lesen und schreiben'),
  };

  async exportExcel() {
    let excel: any = [];
    for (const role of this.roles.rows) {
      let row = {
        rolle: role.Rolle,
        typ: null,
        art: null,
        bezeichnung: role.Rolle,
        rechte: role.Berechtigung,
      };

      excel.push(row);

      const res = await firstValueFrom(this.apiservice.getRoleByID(role.ID));

      if (res) {
        let userRoleRightsview = res.view;
        userRoleRightsview.forEach(item => {
          let row = {
            rolle: role.Rolle,
            typ: 'Rechte',
            art: 'Ansicht',
            bezeichnung: item.descriptor,
            rechte: item.value == true ? 'ja' : 'nein',
          };
          excel.push(row);
        });

        let userRoleRightsprogramm = res.program;
        userRoleRightsprogramm.forEach(item => {
          let row = {
            rolle: role.Rolle,
            typ: 'Rechte',
            art: 'Programm',
            bezeichnung: item.descriptor,
            rechte: item.value == true ? 'ja' : 'nein',
          };
          excel.push(row);
        });

        (Object.entries(res.type || {}) as [string, any[]][]).forEach(([key, value]) => {
          const result = Object.values(this.sotyp).find(item => item['id'].toString() === key);
          const bezeichnung = result['bezeichnung'] ?? 'Unbekannt';

          (value || []).forEach(item => {
            let row = {
              rolle: role.Rolle,
              typ: 'Rechte',
              art: bezeichnung,
              bezeichnung: item.descriptor,
              rechte: item.value == true ? 'ja' : 'nein',
            };
            excel.push(row);
          });
        });

        const roleUsers = this.users.rows.filter(u => u.KPROLID == role.ID);
        if (roleUsers.length == 0) {
          let row = {
            rolle: role.Rolle,
            typ: 'Benutzer',
            art: null,
            bezeichnung: 'keine',
            rechte: null,
          };
          excel.push(row);
        }
        roleUsers.forEach(item => {
          let row = {
            rolle: role.Rolle,
            typ: 'Benutzer',
            art: null,
            bezeichnung: item.UserMail,
            rechte: null,
          };
          excel.push(row);
        });

        const userRoleGroups = this.groups.filter(u => res.groups.includes(u.id));
        if (userRoleGroups.length == 0) {
          let row = {
            rolle: role.Rolle,
            typ: 'Gruppen',
            art: 'Benutzergruppe',
            bezeichnung: 'keine',
            rechte: null,
          };
          excel.push(row);
        }
        userRoleGroups.forEach(item => {
          let row = {
            rolle: role.Rolle,
            typ: 'Gruppen',
            art: 'Benutzergruppe',
            bezeichnung: item.Bezeichnung,
            rechte: item.Rechte == 1 ? 'lesen' : 'lesen und schreiben',
          };
          excel.push(row);
        });

        const userRoleAuftragGroups = this.auftragsGroups.filter(u => res.auftraggroups.includes(u.id));
        if (userRoleAuftragGroups.length == 0) {
          let row = {
            rolle: role.Rolle,
            typ: 'Gruppen',
            art: 'Auftragsgruppe',
            bezeichnung: 'keine',
            rechte: null,
          };
          excel.push(row);
        }
        userRoleAuftragGroups.forEach(item => {
          let row = {
            rolle: role.Rolle,
            typ: 'Gruppen',
            art: 'Auftragsgruppe',
            bezeichnung: item.Bezeichnung,
            rechte: null,
          };
          excel.push(row);
        });
      }
    }
    this.excelService.exportAsExcelFile(excel, this.mrTranslate.transform('Benutzerverwaltung'));
  }

  handleExpireChange($event) {
    this.optShowExpireDate = false;
    if (this.optPWExpire == '1') {
      this.optShowExpireDate = true;
    }
  }

  addRolle() {
    this.showEditRoleTitle = 'Neue Rolle anlegen';
    this.formRole.controls.id.setValue(0);
    this.formRole.controls.rolle.setValue('');
    this.formRole.controls.rechte.setValue(1);

    this.showEditRole = true;
  }

  sendRechte() {
    if (this.selectedRole) {
      if (this.selectedRole.Rechte != 6) {
        this.selectedUserRights.view.forEach((item: any) => {
          if (item.key == 'AllowVBEVER') {
            item.value = false;
          }
        });
      }

      if (this.selectedRoleRechte < 3) {
        this.selectedUserRights.program.forEach(item => (item.value = false));
        Object.keys(this.selectedUserRights.type).forEach(key => {
          this.selectedUserRights.type[key].forEach(item => (item.value = false));
        });
      }

      let toSend: any = {
        status: 'updateRoleRechte',
        id: this.selectedRole.ID,
        rights: this.selectedUserRights,
        groups: this.selectedUserGroups,
        auftraggroups: this.selectedUserAuftragGroups,
        users: this.selectedUserRole,
        karteID: localStorage.getItem('karteFileID'),
      };
      this.apiservice
        .setRole(toSend)
        .pipe(first())
        .subscribe((res: any) => {
          if (res && res != '') {
            this.users.rows = res.rows;
            this.selectedUserRole = this.users.rows.filter(user => user.KPROLID == this.selectedRole.ID);
            this.toastr.success(this.mrTranslate.transform('Rechte gespeichert'));
          } else {
            this.toastr.warning(this.mrTranslate.transform('Beim Speichern der Rechte ist ein Fehler aufgetreten'));
          }
        });
    }
  }

  editRolle(row: any) {
    this.showEditRoleTitle = 'Rolle bearbeiten';
    this.formRole.controls.id.setValue(row.ID);
    this.formRole.controls.rolle.setValue(row.Rolle);
    this.formRole.controls.rechte.setValue(row.Rechte);

    this.showEditRole = true;
  }

  async deleteRolle(id: number) {
    const text = this.mrTranslate.transform('Sind Sie sicher, dass Sie diese Rolle löschen möchten?');

    const ok = await this.confirmService.danger(text);
    if (ok) {
      let toSend = {
        status: 'deleteRole',
        id: id,
      };

      this.apiservice
        .setRole(toSend)
        .pipe(first())
        .subscribe((res: any) => {
          if (res && res != '') {
            this.roles.rows = res.roles.rows;
            this.toastr.success(this.mrTranslate.transform('Rolle wurde gelöscht.'));
            this.showEditRole = false;
          } else {
            this.toastr.warning(this.mrTranslate.transform('Beim Löschen der Rolle ist ein Fehler aufgetreten'));
          }
        });
    }
  }

  sendEditRolle() {
    this.formRole.markAsTouched();
    if (this.formRole.valid) {
      let vals = this.formRole.value;
      let toSend = {
        status: 'updateRole',
        id: vals.id,
        vals: this.formRole.value,
      };

      this.apiservice
        .setRole(toSend)
        .pipe(first())
        .subscribe((res: any) => {
          if (res && res != '') {
            this.roles.rows = res.roles.rows;
            this.toastr.success(this.mrTranslate.transform('Daten gespeichert'));
            this.showEditRole = false;
            if (this.curSelectedRole) {
              if (this.curSelectedRole.Rechte.toString() != vals.rechte) {
                if (this.curSelectedRole.Rechte > parseInt(vals.rechte.toString())) {
                  this.curSelectedRole.Rechte = vals.rechte;
                  this.selectedRole = this.curSelectedRole;
                  this.sendRechte();
                }

                this.curSelectedRole.Rechte = vals.rechte;
                this.selectedRole = this.curSelectedRole;
              }

              this.selectionRoleChanged(this.curSelectedRole);
            }
          } else {
            this.toastr.warning(this.mrTranslate.transform('Beim Speichern der Rolle ist ein Fehler aufgetreten'));
          }
        });
    } else {
      this.toastr.warning(this.mrTranslate.transform('Bezeichnung fehlt'));
    }
  }

  selectionRoleChanged(row: any) {
    this.selectedRoleRechte = row.Rechte;
    this.curSelectedRole = row;
    this.selectedUserRole = [...this.users.rows.filter(user => user.KPROLID == row.ID)];

    if (row) {
      this.apiservice
        .getRoleByID(row.ID)
        .pipe(first())
        .subscribe((res: any) => {
          this.selectedUserRights = undefined;
          this.selectedUserGroups = [];
          this.selectedUserAuftragGroups = [];
          if (res) {
            this.selectedUserRights = res;
            this.selectedUserGroups = res.groups;
            this.selectedUserAuftragGroups = res.auftraggroups;

            if (this.selectedRoleRechte < 3) {
              this.selectedUserRights.program.forEach(item => (item.value = false));
              Object.keys(this.selectedUserRights.type).forEach(key => {
                this.selectedUserRights.type[key].forEach(item => (item.value = false));
              });
            }

            this.chkType = {};
            this.chkView = 0;
            this.chkPro = 0;

            this.changeHeaderFieldState('view', -1);
            this.changeHeaderFieldState('pro', -1);
            Object.entries(res.type).forEach(([key, value]) => {
              if (!this.chkType[key]) {
                this.chkType[key] = 0;
              }
              this.chkType[key] = 0;
              this.changeHeaderFieldState('typ', key);
            });
          }
        });
    }
  }

  changeHeaderField(values: any, field: string, keys: any): void {
    let val = values.currentTarget.checked;
    if (field == 'view') {
      if (val == true) {
        this.chkView = 2;
      } else {
        this.chkView = 0;
      }

      this.selectedUserRights.view.forEach(items => {
        items.value = val;
      });
    }
    if (field == 'pro') {
      if (val == true) {
        this.chkPro = 2;
      } else {
        this.chkPro = 0;
      }
      this.selectedUserRights.program.forEach(items => {
        items.value = val;
      });
    }

    if (field == 'typ') {
      if (val == true) {
        this.chkType[keys] = 2;
      } else {
        this.chkType[keys] = 0;
      }

      this.selectedUserRights.type[keys].forEach(items => {
        items['value'] = val;
      });
    }
  }

  changeHeaderFieldState(field: string, keys: any): void {
    let z = 0;
    if (field == 'view') {
      this.selectedUserRights.view.forEach(item => {
        if (item.value) {
          z++;
        }
      });

      if (z != 0 && z != this.selectedUserRights.view.length) {
        this.chkView = 1;
      }
      if (z == this.selectedUserRights.view.length) {
        this.chkView = 2;
      }
    }

    if (field == 'pro') {
      this.selectedUserRights.program.forEach(item => {
        if (item.value) {
          z++;
        }
      });

      if (z != 0 && z != this.selectedUserRights.program.length) {
        this.chkPro = 1;
      }
      if (z == this.selectedUserRights.program.length) {
        this.chkPro = 2;
      }
    }

    if (field == 'typ') {
      this.selectedUserRights.type[keys].forEach(items => {
        if (items['value'] == true) {
          z++;
        }
      });

      if (z != 0 && z != this.selectedUserRights.type[keys].length) {
        this.chkType[keys] = 1;
      }
      if (z == this.selectedUserRights.type[keys].length) {
        this.chkType[keys] = 2;
      }
    }
  }

  activeTabs = {
    roles: true,
    security: false,
  };

  loadRoles() {
    this.apiservice
      .getRoles()
      .pipe(first())
      .subscribe((val: any) => {
        this.roles = val.roles;
        this.activeTabs.roles = true;

        this.loadUsers();
        this.loadGroups();
        this.loadAuftragsGroups();
        this.loadSOTYP();
        this.loadPWini();

        this.spinnerservice.disable();
      });
  }

  loadPWini() {
    this.apiservice
      .getPWini()
      .pipe(first())
      .subscribe((val: any) => {
        this.pwini = val;
        this.optPWkBuch = val.optPWkBuch;
        this.optPWgBuch = val.optPWgBuch;
        this.optPWZahl = val.optPWZahl;
        this.optPWSonder = val.optPWSonder;
        this.optPWMinL = val.optPWMinL;
        this.optAzkBuch = val.optAzkBuch;
        this.optAzgBuch = val.optAzgBuch;
        this.optAzZahl = val.optAzZahl;
        this.optAzSonder = val.optAzSonder;

        this.optPWExpire = val.optPWExpire.toString();
        this.optPWExpireDays = val.optPWExpireDays;
        if (this.optPWExpireDays < 30) {
          this.optPWExpireDays = 30;
        }
        this.optPWHistoryCount = val.optPWHistoryCount;

        this.optPWAdminMinL = val.optPWAdminMinL;
        this.optAdminUsePW = val.optAdminUsePW;
        this.optAdminMFA = val.optAdminMFA;

        if (this.optPWExpire == '1') {
          this.optShowExpireDate = true;
        }

        if (this.optPWkBuch && this.optAzkBuch == 0) this.optAzkBuch = 1;
        if (this.optPWgBuch && this.optAzgBuch == 0) this.optAzgBuch = 1;
        if (this.optPWZahl && this.optAzZahl == 0) this.optAzZahl = 1;
        if (this.optPWSonder && this.optAzSonder == 0) this.optAzSonder = 1;
      });
  }

  loadSOTYP() {
    this.apiservice
      .getSOTYP()
      .pipe(first())
      .subscribe(val => {
        this.sotyp = val;
      });
  }

  loadGroups() {
    this.apiservice
      .getGroups()
      .pipe(first())
      .subscribe((val: any) => {
        this.groups = val;
      });
  }

  loadAuftragsGroups() {
    this.apiservice
      .getAuftragsGroups()
      .pipe(first())
      .subscribe((val: any) => {
        this.auftragsGroups = val;
      });
  }

  loadUsers() {
    this.apiservice
      .getUsers()
      .pipe(first())
      .subscribe((users: any) => {
        if (this.users) {
          this.users.rows = users.rows;
        } else {
          this.users = users;
        }
        // this.actionDefs = [
        //   {label:"Bearbeiten",id:"bearbeiten",enabled:true},
        //   {label:"Löschen",id:"löschen",enabled:true},
        // ]
        // if(this.useMFA == true){
        //   this.actionDefs.push({label:"MFA zurücksetzen",id:"mfa",enabled:true});
        // }
        // users.columns.forEach(x=> this.colDefs.push(
        //   {
        //     displayName: this.titleCase.transform(x.bezeichnung),
        //     field:x.id,
        //     hidden: this.hideID.transform(x.id.toLowerCase(),this.hideIDColumns),
        //     filter: ColumnFilterComponent
        //   }));
      });
  }
  setAction(event) {
    switch (event.action.id) {
      case 'löschen':
        this.deleteUser(event.context.id);
        break;
      case 'bearbeiten':
        this.editUser(event.context);
        break;
      case 'mfa':
        this.resteMFA(event.context);
        break;
      default:
        break;
    }
  }

  setPWSecurity() {
    let PWResetRequired = 0;

    if (this.pwini.optPWMinL != this.optPWMinL) PWResetRequired = 1;
    if (this.pwini.optPWkBuch != this.optPWkBuch) PWResetRequired = 1;
    if (this.pwini.optPWgBuch != this.optPWgBuch) PWResetRequired = 1;
    if (this.pwini.optPWZahl != this.optPWZahl) PWResetRequired = 1;
    if (this.pwini.optPWSonder != this.optPWSonder) PWResetRequired = 1;
    if (this.pwini.optAzkBuch != this.optAzkBuch) PWResetRequired = 1;
    if (this.pwini.optAzgBuch != this.optAzgBuch) PWResetRequired = 1;
    if (this.pwini.optAzZahl != this.optAzZahl) PWResetRequired = 1;
    if (this.pwini.optAzSonder != this.optAzSonder) PWResetRequired = 1;
    if (!this.optPWkBuch) this.optAzkBuch = 0;
    if (!this.optPWgBuch) this.optAzgBuch = 0;
    if (!this.optPWZahl) this.optAzZahl = 0;
    if (!this.optPWSonder) this.optAzSonder = 0;

    let toSend = {
      PWResetRequired: PWResetRequired,
      optPWMinL: this.optPWMinL,
      optPWkBuch: this.optPWkBuch ? 1 : 0,
      optPWgBuch: this.optPWgBuch ? 1 : 0,
      optPWZahl: this.optPWZahl ? 1 : 0,
      optPWSonder: this.optPWSonder ? 1 : 0,
      optAzkBuch: this.optAzkBuch,
      optAzgBuch: this.optAzgBuch,
      optAzZahl: this.optAzZahl,
      optAzSonder: this.optAzSonder,
      optPWExpire: this.optPWExpire,
      optPWExpireDays: this.optPWExpireDays,
      optPWHistoryCount: this.optPWHistoryCount,
      optAdminMFA: this.optAdminMFA ? 1 : 0,
      optAdminUsePW: this.optAdminUsePW ? 1 : 0,
      optPWAdminMinL: this.optPWAdminMinL,
    };

    this.apiservice
      .setPWini(toSend)
      .pipe(first())
      .subscribe((res: any) => {
        if ((res.status = 'OK')) {
          this.toastr.success(this.mrTranslate.transform('Daten gespeichert'));
        } else {
          this.toastr.error(this.mrTranslate.transform('Beim Speichern ist ein Fehler aufgetreten'));
        }
      });
  }

  async deleteAuftragGroup(id: number) {
    const text = this.mrTranslate.transform('Sind Sie sicher, dass Sie diese Auftragsgruppe löschen möchten?');
    const ok = await this.confirmService.danger(text);
    if (ok) {
      this.apiservice
        .deleteAuftragGroup(id)
        .pipe(first())
        .subscribe((res: any) => {
          if (res) {
            this.toastr.success(this.mrTranslate.transform('Auftragsgruppe wurde gelöscht.'));
          }
          this.auftragsGroups = res;
          if (this.curSelectedRole) this.selectionRoleChanged(this.curSelectedRole);
        });
    }
  }

  tabChange(key: string) {
    for (const act of Object.keys(this.activeTabs)) {
      if (act != key) {
        this.activeTabs[act] = false;
      } else {
        this.activeTabs[act] = true;
      }
    }
  }

  close() {
    this.closedialog.next(true);
  }

  async deleteGroup(id: number) {
    const ok = await this.confirmService.danger(
      this.mrTranslate.transform('Sind Sie sicher, dass Sie diese Gruppe löschen möchten?')
    );
    if (ok) {
      this.apiservice
        .deleteGroup(id)
        .pipe(first())
        .subscribe((res: any) => {
          if (res) {
            this.toastr.success(this.mrTranslate.transform('Gruppe wurde gelöscht.'));
          }
          this.groups = res;
          if (this.curSelectedRole) this.selectionRoleChanged(this.curSelectedRole);
        });
    }
  }

  async resteMFA(row: any) {
    const ok = await this.confirmService.danger(
      this.mrTranslate.transform('Sind Sie sicher, dass Sie die Multi-Faktor-Authentifizierung zurücksetzen möchten?')
    );
    if (ok) {
      let items = {
        id: row['id'],
        email: row['UserMail'],
        mfaaktiv: false,
      };
      this.apiservice.saveGoogleCode(items).subscribe((data: any) => {
        this.toastr.success(this.mrTranslate.transform('MFA wurde zurückgesetzt.'));
      });
    }
  }

  async deleteUser(id: number) {
    const ok = await this.confirmService.danger(
      this.mrTranslate.transform('Sind Sie sicher, dass Sie diesen Benutzer löschen möchten?')
    );
    if (ok) {
      this.apiservice
        .deleteUser(id)
        .pipe(first())
        .subscribe(val => {
          if (val) {
            this.toastr.success(this.mrTranslate.transform('Benutzer wurde gelöscht.'));
          }
          this.users = val;
          if (this.curSelectedRole) this.selectionRoleChanged(this.curSelectedRole);
        });
    }
  }

  async addUser() {
    var imax;
    const val = await firstValueFrom(this.apiservice.getmaxUser());

    if (val) {
      imax = val;

      if (val > this.users.rows.length) {
        this.formUser.reset();
        this.formUser.controls.id.setValue(0);
        this.formUser.controls.role.setValue(this.curSelectedRole.ID);
        this.showUserGroupTitle = 'Neue Benutzer anlegen';
        this.isUserEditVisible = true;
        this.base64Image = '';

        setTimeout(() => {
          document.forms[0]['_image'].src = '/assets/icons/user-solid.svg';
          document.forms[0]['vertical-radio1'].checked = true;
          document.forms[0]['vertical-radio2'].checked = false;
          document.forms[0]['vertical-radio3'].checked = false;
        }, 100);
      } else {
        this.toastr.error(this.mrTranslate.transform('Die maximale Anzahl an Benutzern ist erreicht'));
      }
    } else {
      this.toastr.error(this.mrTranslate.transform('Fehler beim Lesen der Bnutzerlizenz'));
    }
  }

  editAufGruppe() {
    this.formUserAuftragGroup.markAsTouched();
    let vals = this.formUserAuftragGroup.value;
    if (this.formUserAuftragGroup.valid) {
      if (
        this.auftragsGroups.some(usr => usr.Bezeichnung.toLowerCase() == vals.name.toLowerCase() && usr.id != vals.id)
      ) {
        this.toastr.error(this.mrTranslate.transform('Gruppe existiert bereits'));
        return;
      }

      let toSend: any = {
        id: vals.id,
        Bezeichnung: vals.name,
        Kostenstelle: vals.kost,
      };

      if (toSend) {
        this.apiservice
          .setAuftragGroups(toSend)
          .pipe(first())
          .subscribe((res: any) => {
            if (res && !res.errors && res.length > 0) {
              this.auftragsGroups = res;
              this.toastr.success(this.mrTranslate.transform(`Daten gespeichert`));
              this.showAufGroupEdit = false;
              if (this.curSelectedRole) this.selectionRoleChanged(this.curSelectedRole);
            } else {
              this.toastr.warning(
                res.errors.map(err => this.mrTranslate.transform(err)).join('\n'),
                this.mrTranslate.transform(`Ein Fehler ist aufgetreten`)
              );
            }
          });
      }
    }
  }

  showEditAufGruppe(id: any) {
    let item = this.auftragsGroups.find(el => el.id == id);
    this.showEditAuftragsGroupTitle = 'Auftragsgruppe bearbeiten';
    this.formUserAuftragGroup.controls.id.setValue(id);
    this.formUserAuftragGroup.controls.name.setValue(item.Bezeichnung);
    this.formUserAuftragGroup.controls.kost.setValue(item.Kostenstelle);
    this.showAufGroupEdit = true;
  }

  editGruppe() {
    this.formUserGroup.markAsTouched();
    let vals = this.formUserGroup.value;
    if (this.formUserGroup.valid) {
      if (this.groups.some(usr => usr.Bezeichnung.toLowerCase() == vals.name.toLowerCase() && usr.id != vals.id)) {
        this.toastr.error(this.mrTranslate.transform('Gruppe existiert bereits'));
        return;
      }

      let toSend: any = {
        id: vals.id,
        Bezeichnung: vals.name,
        Rechte: vals.rechte,
      };

      this.apiservice
        .setUserGroups(toSend)
        .pipe(first())
        .subscribe((res: any) => {
          if (res && !res.errors && res.length > 0) {
            this.groups = res;
            this.toastr.success(this.mrTranslate.transform(`Daten gespeichert`));
            this.isGroupEditVisible = false;
            if (this.curSelectedRole) this.selectionRoleChanged(this.curSelectedRole);
          } else {
            this.toastr.warning(
              res.errors.map(err => this.mrTranslate.transform(err)).join('\n'),
              this.mrTranslate.transform(`Ein Fehler ist aufgetreten`)
            );
          }
        });
    } else {
      if (vals.name == '') {
        this.toastr.error(this.mrTranslate.transform('Geben Sie eine Bezeichnung ein'));
        return;
      }
    }
  }

  showAddGruppe() {
    this.showEditGroupTitle = 'Neue Gruppe anlegen';
    this.formUserGroup.reset();
    this.formUserGroup.controls.id.setValue('INSERT');
    this.isGroupEditVisible = true;
  }

  showAddAuftragGruppe() {
    this.showEditAuftragsGroupTitle = 'Neuen Auftragsgruppe anlegen';
    this.formUserAuftragGroup.reset();
    this.formUserAuftragGroup.controls.id.setValue('INSERT');
    this.showAufGroupEdit = true;
  }

  async deleteGruppe(id: any) {
    const ok = await this.confirmService.danger(
      this.mrTranslate.transform('Sind Sie sicher, dass Sie diese Gruppe löschen möchten?')
    );
    if (ok) {
      this.apiservice
        .deleteGroup(id)
        .pipe(first())
        .subscribe((res: any) => {
          if (res) {
            this.toastr.success(this.mrTranslate.transform('Gruppe erfolgreich gelöscht.'));
          }
          this.groups = res;
          if (this.curSelectedRole) this.selectionRoleChanged(this.curSelectedRole);
        });
    }
  }

  editShowGruppe(id: any) {
    let item = this.groups.find(el => el.id == id);
    this.showEditGroupTitle = 'Gruppe bearbeiten';
    this.formUserGroup.controls.id.setValue(item.id);
    this.formUserGroup.controls.name.setValue(item.Bezeichnung);
    this.formUserGroup.controls.rechte.setValue(item.Rechte);
    this.isGroupEditVisible = true;
  }

  editUser(row: any) {
    this.edituser = row;
    this.showUserGroupTitle = 'Benutzer bearbeiten';
    this.isUserEditVisible = true;

    this.formUser.controls.id.setValue(row.id);
    this.formUser.controls.username.setValue(row.UserName);
    this.formUser.controls.alias.setValue(row.Alias);
    this.formUser.controls.pw.setValue('********************');
    this.formUser.controls.role.setValue(row.KPROLID);
    this.formUser.controls.vname.setValue(row.Vorname);
    this.formUser.controls.nname.setValue(row.Nachname);
    this.formUser.controls.email.setValue(row.UserMail);
    this.formUser.controls.mobil.setValue(row.mobil);
    this.formUser.controls.optalv.setValue(false);
    this.formUser.controls.optebl.setValue(false);

    this.base64Image = '';

    setTimeout(() => {
      document.forms[0]['_image'].src = '/assets/icons/user-solid.svg';
      document.forms[0]['vertical-radio1'].checked = false;
      document.forms[0]['vertical-radio2'].checked = false;
      document.forms[0]['vertical-radio3'].checked = false;

      if (
        (row['Eisenbahnbetriebsleiter (EBL)'] == 0 || row['Eisenbahnbetriebsleiter (EBL)'] == null) &&
        (row['Anlagenverantwortlicher (ALV)'] == 0 || row['Anlagenverantwortlicher (ALV)'] == null)
      ) {
        document.forms[0]['vertical-radio1'].checked = true;
      }

      if (row['Eisenbahnbetriebsleiter (EBL)'] == 0 && row['Anlagenverantwortlicher (ALV)'] == 1) {
        document.forms[0]['vertical-radio2'].checked = true;
        this.formUser.controls.optalv.setValue(true);
      }

      if (row['Eisenbahnbetriebsleiter (EBL)'] == 1 && row['Anlagenverantwortlicher (ALV)'] == 0) {
        document.forms[0]['vertical-radio3'].checked = true;
        this.formUser.controls.optebl.setValue(true);
      }

      if (row.UserImageBase64 != '') {
        this.base64Image = row.UserImageBase64;

        var enc = atob(row.UserImageBase64);

        var image = new File([enc], 'random.jpg', {
          type: 'image/jpeg',
        });
        var file = b64toBlob(row.UserImageBase64, 'image/jpeg', 512);
        var fileb = new File(['akkaka'], 'ranom', {
          type: 'image/jpeg',
        });
        console.log(file.size);
        console.log(fileb.size);
        this.file = URL.createObjectURL(file);

        console.log(this.file);

        this._file = this.file;
      }
    }, 100);
  }

  onFileClear(part: any) {
    this.file = '';
    this.base64Image = '';
    this._file = '/assets/icons/user-solid.svg';

    this.resetInput();
  }

  onFileOpen(part: any) {
    let input = document.createElement('input');
    input.type = 'file';
    input.accept = '.jpg';
    input.onchange = _ => {
      // you can use this method to get file and perform respective operations
      let files = Array.from(input.files);

      if (files.length > 0) {
        const reader = new FileReader();

        reader.onloadend = () => {
          let r = reader.result as String;
          var splitted = r.split(',');
          this.base64Image = splitted[1];
        };

        reader.readAsDataURL(files[0]);

        this._file = URL.createObjectURL(files[0]);
        this.file = this._file;
      }
    };
    input.click();
  }

  resetInput() {
    const input = document.getElementById('avatar-input-file') as HTMLInputElement;
    if (input) {
      input.value = '';
    }
  }

  setVerantwortung(val: any) {
    document.forms[0]['vertical-radio1'].checked = false;
    document.forms[0]['vertical-radio2'].checked = false;
    document.forms[0]['vertical-radio3'].checked = false;

    if (val === 'optkein') {
      document.forms[0]['vertical-radio1'].checked = true;
    }
    if (val === 'optalv') {
      document.forms[0]['vertical-radio2'].checked = true;
    }
    if (val === 'optebl') {
      document.forms[0]['vertical-radio3'].checked = true;
    }
  }

  updateUser(event) {
    let vals = this.formUser.value;
    this.formUser.markAllAsTouched();

    if (this.formUser.valid) {
      if (vals.mobil.startsWith('00')) {
        vals.mobil = vals.mobil.replace('00', '+');
      }

      if (!vals.mobil.startsWith('+')) {
        this.toastr.error(this.mrTranslate.transform('Geben Sie bei der Mobilnummer die Länderkennung (+49..) ein'));
        return;
      }

      if (vals.pw != '********************') {
        let validPW = this.validatePassword(vals.pw);
        if (validPW != '') {
          this.toastr.error(this.mrTranslate.transform(validPW));
          return;
        }
      }

      this.apiservice
        .getPWini()
        .pipe(first())
        .subscribe((val: any) => {
          this.edituser = {};
          this.edituser.user = {};

          this.edituser.optPWExpire = val?.optPWExpire ?? 0;
          this.edituser.optPWExpireDays = val?.optPWExpireDays ?? 0;
          this.edituser.optPWHistoryCount = 0;
          this.edituser.id = vals.id;
          this.edituser.user.UserName = vals.username;
          this.edituser.user.Alias = vals.alias;
          this.edituser.user.Vorname = vals.vname;
          this.edituser.user.Nachname = vals.nname;
          this.edituser.user.UserMail = vals.email;
          this.edituser.user.mobil = vals.mobil;
          this.edituser.user.role = vals.role;
          this.edituser.user.USER_EBL = 0;
          this.edituser.user.USER_ALV = 0;

          if (document.forms[0]['vertical-radio2'].checked) {
            this.edituser.user.USER_ALV = 1;
          }

          if (document.forms[0]['vertical-radio3'].checked) {
            this.edituser.user.USER_EBL = 1;
          }

          if (vals.pw != '********************') this.edituser.pwhash = shajs('sha256').update(vals.pw).digest('hex');
          else this.edituser.pwhash = null;

          this.edituser.user.UserImageBase64 = this.base64Image;

          this.apiservice
            .updateUser(this.edituser)
            .pipe(first())
            .subscribe((val: any) => {
              if (val.message.toLowerCase() === 'ok') {
                this.loadUsers();
                this.isUserEditVisible = false;
                if (this.curSelectedRole) this.selectionRoleChanged(this.curSelectedRole);

                this.toastr.success(this.mrTranslate.transform('Benutzer wurde erfolgreich geändert'));
              } else {
                this.toastr.error(this.mrTranslate.transform('Leider ist ein Fehler aufgetreten.'));
              }
            });
        });
    } else {
      if (vals.mobil == null) {
        this.toastr.error(this.mrTranslate.transform('Geben Sie bei der Mobilnummer ein'));
        return;
      }
    }
  }

  validatePassword(pw: string) {
    if (pw == undefined) {
      return 'Das Passwort muss mindestens (' + this.optPWMinL.toString() + ') Zeichen enthalten.';
    }

    if (pw == '') {
      return 'Das Passwort muss mindestens (' + this.optPWMinL.toString() + ') Zeichen enthalten.';
    }

    let hasNumber = new RegExp('[0-9]');
    let hasUpperChar = new RegExp('[A-Z]');
    let hasLowerChar = new RegExp('[a-z]');
    let hasSymbols = new RegExp(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/);

    let countUpper: number = 0;
    let countLower: number = 0;
    let countNumber: number = 0;
    let countSymbols: number = 0;

    if (pw.length < this.optPWMinL) {
      return 'Das Passwort muss mindestens (' + this.optPWMinL.toString() + ') Zeichen enthalten.';
    }

    if (this.optPWkBuch) {
      if (!pw.match(/[a-z]/)) {
        return 'Das Passwort muss mindestens (' + this.optAzkBuch.toString() + ') Kleinbuchstaben enthalten.';
      }
      countLower = (pw.match(/[a-z]/g) || []).length;
      if (this.optAzkBuch > countLower) {
        return 'Das Passwort muss mindestens (' + this.optAzkBuch.toString() + ') Kleinbuchstaben enthalten.';
      }
    }

    if (this.optPWgBuch) {
      if (!pw.match(/[A-Z]/)) {
        return 'Das Passwort muss mindestens (' + this.optAzgBuch.toString() + ') Grossbuchstaben enthalten.';
      }
      countUpper = (pw.match(/[A-Z]/g) || []).length;
      if (this.optAzgBuch > countUpper) {
        return 'Das Passwort muss mindestens (' + this.optAzgBuch.toString() + ') Grossbuchstaben enthalten.';
      }
    }

    if (this.optPWZahl) {
      if (!pw.match(/[0-9]/)) {
        return 'Das Passwort muss mindestens (' + this.optAzZahl.toString() + ') Zahlen enthalten.';
      }
      countNumber = (pw.match(/[0-9]/g) || []).length;
      if (this.optAzZahl > countNumber) {
        return 'Das Passwort muss mindestens (' + this.optAzZahl.toString() + ') Zahlen enthalten.';
      }
    }

    if (this.optPWSonder) {
      if (!pw.match(hasSymbols)) {
        return (
          'Das Passwort muss mindestens (' + this.optAzSonder.toString() + ') unterschiedliche Sonderzeichen enthalten.'
        );
      }
      countSymbols = pw.match(/[@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g).length;
      if (this.optAzSonder > countSymbols) {
        return (
          'Das Passwort muss mindestens (' + this.optAzSonder.toString() + ') unterschiedliche Sonderzeichen enthalten.'
        );
      }
    }

    return '';
  }
}

function b64toBlob(b64Data, contentType, sliceSize) {
  contentType = contentType || '';
  sliceSize = sliceSize || 512;

  var byteCharacters = atob(b64Data);
  var byteArrays = [];

  for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    var slice = byteCharacters.slice(offset, offset + sliceSize);

    var byteNumbers = new Array(slice.length);
    for (var i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    var byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }

  console.log(byteArrays);

  return new File(byteArrays, 'pot', { type: contentType });
}

type iFECol = {
  bezeichnung: string;
  id: string;
  optionalData?: any;
  pflichtFeld?: string;
  type?: string;
  wListe?: any[];
};
